<template>
  <div class="search-options-data">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="配置搜索" name="1">
        <div class="setting-item">
          <div class="clearFloat" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
            <div class="goManageBack mt16" @click="setClick()">配置搜索</div>
            <div class="getDataBtn mt16" @click="btnClick()">查看数据响应结果</div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="字段匹配" name="2">
        <div class="setting-item">
          <div class="verticallyCenter">
            <span class="mr16">一级标签</span>
            <div class="select-box flex1">
              <el-select v-model="firstField" placeholder="一级标签">
                <el-option v-for="(item, index) in fieldList1" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(1)"></span>
            </div>
          </div>
          <div class="verticallyCenter mt8">
            <span class="mr16">二级标签</span>
            <div class="select-box flex1">
              <el-select v-model="secondField" placeholder="二级标签">
                <el-option v-for="(item, index) in fieldList2" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(2)"></span>
            </div>
          </div>
          <div class="verticallyCenter mt8">
            <span class="mr16">三级标签</span>
            <div class="select-box flex1">
              <el-select v-model="thirdField" placeholder="三级标签">
                <el-option v-for="(item, index) in fieldList3" :key="index" :value="item.value" :label="item.title"
                  >{{ item.title }}
                </el-option>
              </el-select>
              <span class="del-btn icon-portal-close-one" @click="clearClick(3)"></span>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '3')"
        title="高级设置"
        name="3"
      >
       <div class="content-item verticallyCenter">
          <el-checkbox v-model="showForeignSearch">外文检索</el-checkbox>
        </div>
        <div class="content-item verticallyCenter mt12">
          <el-checkbox v-model="showHighSearch">高级检索</el-checkbox>
        </div>
        <div class="content-item verticallyCenter mt12">
          <el-checkbox v-model="showAiSearch">AI检索</el-checkbox>
          <el-tooltip
            class="item"
            :hide-after="1500"
            effect="dark"
            content="仅支持超星发现配置"
            placement="top"
          >
            <span class="tips-btn icon-portal-info2"></span>
          </el-tooltip>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import Qs from "qs"
import $ from "jquery"
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions } from "utils"
import { updateSubPageMapping } from "utils/updateData/publicDataUtils/subPageUpdateData"
import { button_children } from "materials/button/menus/index.js"
import { isExist } from '../../../../../utils'
export default {
  name: "search-options-data",
  props: {
    options: { type: Object },
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      fieldList: [
        { value: "3", title: "下拉框" },
        { value: "1", title: "筛选项1" },
        { value: "2", title: "筛选项2" }
      ],
      searchTypeList: [],
      selectIndex: 0,
      tabIndex: 0,
      radioIndex: 0,
      selectOptions: [],
      searchList: [],
      that: this,
      appId: null,
      selectIds: null,
      tabsIds: null,
      radioIds: null
    }
  },
  created() {
    this.getFieldList()
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.listenData)
  },
  computed: {
    showForeignSearch: {
      get() {
        return this.options.hasOwnProperty("showForeignSearch") ? this.options.showForeignSearch : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showForeignSearch", false)
        this.addSearchBtn(newVal, "searchForeign")
      }
    },
    showHighSearch: {
      get() {
        return this.options.hasOwnProperty("showHighSearch") ? this.options.showHighSearch : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showHighSearch", false)
        this.addSearchBtn(newVal, "searchHigh")
      }
    },
    showAiSearch: {
      get() {
        return this.options.hasOwnProperty("showAiSearch") ? this.options.showAiSearch : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showAiSearch", false)
        this.addSearchBtn(newVal, "searchAi")
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      return this.$getOptions(this.ids)
    },
    firstField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "firstField", "firstField", "3")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "firstField", false)
      }
    },
    secondField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "secondField", "secondField", "1")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "secondField", false)
      }
    },
    thirdField: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "thirdField", "thirdField", "2")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "thirdField", false)
        console.log("this.thirdField :>>", this.thirdField)
      }
    },
    fieldList1() {
      return this.fieldList.filter(item => {
        return item.value != this.secondField && item.value != this.thirdField
      })
    },
    fieldList2() {
      return this.fieldList.filter(item => {
        return item.value != this.firstField && item.value != this.thirdField
      })
    },
    fieldList3() {
      return this.fieldList.filter(item => {
        return item.value != this.firstField && item.value != this.secondField
      })
    },
    noCacheComponent: {
      get() {
        return this.getOptions && this.getOptions.noCacheComponent ? this.getOptions.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null, {
          rect_id: this.ids.rect_id,
          container_id: this.ids.container_id
        })
      }
    }
  },
  methods: {
    addSearchBtn(show, type) {
      const getElement = this.getElementInLayout()
      // const searchType = "search" + type
      // let index = getElement.searchElementInLayout.findIndex(item => {
      //   return item.searchType === searchType
      // })
      const buttonIds = this.findElementIds(getElement.searchElementInLayout, "searchButton")?.ids
      const element = this.findElementIds(getElement.searchElementInLayout, type)?.element   
      if (!element) {
        const button = button_children[0]
        let options = JSON.parse(JSON.stringify(button.attribute.options))
        options.searchType = type
        options.isShow = show
        options.content = type === "searchAi" ? "AI检索" : type === "searchHigh" ? "高级检索" : "外文检索"
        options.left = type === "searchAi" ? 280 : type === "searchHigh" ? 150 : 20
        options.topType = "%"
        options.top = 70
        let param = {
          ...this.ids,
          uid: getElement.searchUid,
          elementOptions: options,
        }
        if (isExist(buttonIds.elementInAutoLayoutId)) {
          param.elementInLayoutId = buttonIds.elementInLayoutId
          param.insertIndex = 3
          param.elementOptions.elementInLayoutId = buttonIds.elementInLayoutId
          this.$store.dispatch(this.request_prefix + "/addAutoLayoutElement", param)
        } else {
          this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
        }
      } else {
        // this.$changeOptionsEV(show, "isShow", false, null, {
        //   container_id: this.ids.container_id,
        //   rect_id: this.ids.rect_id,
        //   uid: getElement.searchUid,
        //   elementInLayoutId: getElement.searchElementInLayout[index].elementInLayoutId,
        //   elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        //   path: this.ids.path
        // })
        this.setOptions(type, "isShow", show)
      }
    },
    findElementIds(element, type) {
      let elementInLayoutId = null
      let component = null
      if (element) {
        component = element.find(item => item.searchType === type)
        if (!component) {
        const autoLayout = element.find(item => item.innerElement === "cxAutoLayout")
          if (autoLayout && autoLayout.elementOptions) {
            component = autoLayout.elementOptions.find(item => item.searchType === type)
            elementInLayoutId = component ? autoLayout?.elementInLayoutId : null
          }
        } else {
          elementInLayoutId = component?.elementInLayoutId
        }
      }
      const getElement = this.getElementInLayout()
      let ids = {
        ...getElement.searchMsg,
        uid: getElement.searchUid,
      }
      isExist(elementInLayoutId) ? ids.elementInLayoutId = elementInLayoutId : ""
      isExist(component?.elementInAutoLayoutId) ? ids.elementInAutoLayoutId = component?.elementInAutoLayoutId : ""
      if (elementInLayoutId !== null) {
        return {
          ids: ids,
          element: component
        }
      } else return null
    },
    setOptions(type, name, value) {
      const getElement = this.getElementInLayout()
      const ids = this.findElementIds(getElement.searchElementInLayout, type)?.ids
      // let showIndex = getElement.searchElementInLayout.findIndex(item => {
      //   return item.searchType === type
      // })
      if (!ids) return
      if (name === "isShow") {
        const element = getElement.searchElementInLayout.find(item => {
          return item.searchType === type
        })
        if (element && element.opacity === 0) {
          this.$changeOptionsEV(100, "opacity", false, null, ids)
        }
      }
      this.$changeOptionsEV(value, name, false, null, ids)
    },
    getFieldList() {
      //根据组件判断下拉选项有哪些
      this.fieldList = []
      const getElement = this.getElementInLayout()
      // let selectShow = getElement.searchElementInLayout.findIndex(item => {
      //   return item.searchType === "searchSelect"
      // })
      // let tabShow = getElement.searchElementInLayout.findIndex(item => {
      //   return item.searchType === "searchTabs"
      // })
      // let radioShow = getElement.searchElementInLayout.findIndex(item => {
      //   return item.searchType === "searchRadio"
      // })
      this.selectIds = this.findElementIds(getElement.searchElementInLayout, "searchSelect")?.ids || null
      this.tabsIds = this.findElementIds(getElement.searchElementInLayout, "searchTabs")?.ids || null
      this.radioIds = this.findElementIds(getElement.searchElementInLayout, "searchRadio")?.ids || null
      if (this.selectIds != null) {
        this.fieldList.push({ value: "3", title: "下拉框" })
        // this.selectElement = $(
        //   `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[selectShow].elementInLayoutId}`
        // )
      } else {
        if (this.firstField == "3") this.firstField = ""
        if (this.secondField == "3") this.secondField = ""
        if (this.thirdField == "3") this.thirdField = ""
      }
      if (this.tabsIds != null) {
        this.fieldList.push({ value: "1", title: "筛选项1" })
        // this.tabElement = $(
        //   `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[tabShow].elementInLayoutId}`
        // )
      } else {
        if (this.firstField == "1") this.firstField = ""
        if (this.secondField == "1") this.secondField = ""
        if (this.thirdField == "1") this.thirdField = ""
      }
      if (this.radioIds != null) {
        this.fieldList.push({ value: "2", title: "筛选项2" })
        // this.radioElement = $(
        //   `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${getElement.searchUid}-elementInLayoutId_${getElement.searchElementInLayout[radioShow].elementInLayoutId}`
        // )
      } else {
        if (this.firstField == "2") this.firstField = ""
        if (this.secondField == "2") this.secondField = ""
        if (this.thirdField == "2") this.thirdField = ""
      }
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    async setClick() {
      const { pageId, wfwfid, websiteId } = { ...this.$store.state.states.getDataPageIds }
      const params = {
        a: "A2FCFFD092A210FC",
        w: wfwfid,
        p: pageId
      }
      let appId = this.getOptions.appId
      if (!appId) appId = await this.getAppId(params)
      this.$changeOptionsEV(appId, "appId", false)
      window.open(`/engine2/data/api-v2/admin/search/${appId}?w=${websiteId}&p=${pageId}`)
      // 数据自动渲染
      this.appId = appId
      window.addEventListener("storage", this.listenData)
    },
    // 获取appId
    async getAppId(params) {
      return new Promise((resolve, reject) => {
        this.instance({
          method: "post",
          url: "v2/default-app",
          headers: {
            "Content-type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify(params)
        }).then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.appId)
          } else {
            reject("err")
          }
        })
      })
    },
    btnClick() {
      const getElement = this.getElementInLayout()
      const autoLayout = getElement.searchElementInLayout.find(item => item.searchType === "searchAutoLayout")
      if (isExist(this.ids?.elementInAutoLayoutId) && autoLayout) {
        // 搜索样式内部还有自动布局的情况，暂时不允许放入自动布局中，查找不支持会报错，后续优化了查找支持多层嵌套再放开！！
        this.$message({
          type: "error",
          message: "该样式暂不支持放入自动布局中，请切换样式"
        })
        return
      }
      this.getFieldList()
      this.startDraw()
    },
    async startDraw() {
      const that = this
      let appId = this.getOptions.appId
      if (!appId) {
        this.$message({
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.noCacheComponent = true
      // 当字段匹配为空时 隐藏相应的组件
      if (this.firstField != "1" && this.secondField != "1" && this.thirdField != "1") {
        // this.tabElement.hide()
        this.setOptions("searchTabs", "isShow", false)
      } else {
        // this.tabElement.show()
        this.setOptions("searchTabs", "isShow", true)
      }
      if (this.firstField != "2" && this.secondField != "2" && this.thirdField != "2") {
        // this.radioElement.hide()
        this.setOptions("searchRadio", "isShow", false)
      } else {
        // this.radioElement.show()
        this.setOptions("searchRadio", "isShow", true)
      }
      if (this.firstField != "3" && this.secondField != "3" && this.thirdField != "3") {
        // this.selectElement.hide()
        this.setOptions("searchSelect", "isShow", false)
      } else {
        // this.selectElement.show()
        this.setOptions("searchSelect", "isShow", true)
      }
      this.searchList = await this.getSearchList(appId)
      if (this.searchList == "err") return
      if (this.searchList.length == 0) {
        this.$message({
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.setSearchList(this.searchList, this.tabIndex, this.radioIndex, this.selectIndex)
      const getElement = this.getElementInLayout()
      // getElement.searchElementInLayout.forEach(element => {
      //   switch (element.searchType) {
      //     case "searchTabs":
      //       this.tabIndex = element.activeIndex
      //       if (this.firstField == "1") {
      //         this.selectOptions = element.tabsList
      //       }
      //       break
      //     case "searchSelect":
      //       if (this.firstField == "3") {
      //         this.selectIndex = element.selectOptions.findIndex(item => item.label === element.value)
      //         this.selectOptions = element.selectOptions
      //       }
      //       break
      //     case "searchRadio":
      //       this.radioIndex = element.activeIndex
      //       if (this.firstField == "2") {
      //         this.selectOptions = element.radioLists
      //       }
      //       break
      //     default:
      //       break
      //   }
      // })
      this.selectElement = this.findElementIds(getElement.searchElementInLayout, "searchSelect")?.element || null
      this.tabElement = this.findElementIds(getElement.searchElementInLayout, "searchTabs")?.element || null
      this.radioElement = this.findElementIds(getElement.searchElementInLayout, "searchRadio")?.element || null
      let searchData = []
      if (this.tabElement) {
        this.tabIndex = this.tabElement.activeIndex
        if (this.firstField == "1") {
          this.selectOptions = this.tabElement.tabsList
          searchData = this.selectOptions[this.tabIndex]
        }
      }
      if (this.selectElement) {
        if (this.firstField == "3") {
          this.selectIndex = this.selectElement.selectOptions.findIndex(item => item.label === this.selectElement.value)
          this.selectOptions = this.selectElement.selectOptions
          searchData = this.selectOptions[this.selectIndex]
        }
      }
      if (this.radioElement) {
        this.radioIndex = this.radioElement.activeIndex
        if (this.firstField == "2") {
          this.selectOptions = this.radioElement.radioLists
          searchData = this.selectOptions[this.radioIndex]
        }
      }
      this.getSearchFastLink(searchData)
      // this.selectClick()
      // this.tabClick()
      // this.radioClick()
    },
    // 获取当前搜索的快捷入口
    getSearchFastLink(searchData) {
      this.$changeOptionsEV(searchData, "activeSearchData", false, null, this.ids, true)
      this.emitEvent(`searchDataUpdate-${this.ids.container_id}-${this.ids.rect_id}`, {
        type: 0,
        activeData: searchData 
      })
      const searchId = searchData?.content
      const publicId = this.options.publicId
      this.$API.querySearchFastLink({searchId: searchId, publicId: publicId}).then(res=>{
        if (res.data?.code === 1) {
          let list = res.data.data || []
          this.$changeOptionsEV(list, "searchFastLinkData", false, null, this.ids, true)
          this.emitEvent(`searchDataUpdate-${this.ids.container_id}-${this.ids.rect_id}`, {
            type: 1, //一级分类改变
            fastLink: list
          })
        }
      }).catch(err => {})
    },
    // 监听数据改变事件
    emitEvent(key, data, deep = 0) {
      console.log('deep :>>',deep);
      const events = this.$eventBus?._events
      if (!events) return
      if (events[key]) {
        this.$eventBus.$emit(key, data)
      } else if (deep < 5) {
        setTimeout(() => {
          this.emitEvent(key, data, deep + 1)
        }, 200)
      }
    },
    // 点击下拉切换
    // selectClick() {
    //   const that = this
    //   setTimeout(() => {
    //     $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
    //       .find(".cx-select>.el-select .el-select-dropdown__item")
    //       .on("click", function () {
    //         that.firstField = that.getElementInLayout().searchOptions.firstField
    //         that.secondField = that.getElementInLayout().searchOptions.secondField
    //         that.thirdField = that.getElementInLayout().searchOptions.thirdField
    //         if (that.selectIndex == $(this).index()) {
    //           return
    //         }
    //         if (that.firstField == "3") {
    //           const typeId = that.selectOptions[$(this).index()].value
    //           that.selectFun(typeId, that.tabIndex, that.radioIndex, $(this).index())
    //         } else if (that.secondField == "3") {
    //           // 判断是否需要获取搜索引擎
    //           if (that.searchTypeList.length > 0)
    //             that.setSearchTypeList(that.searchTypeList, that.tabIndex, that.radioIndex, $(this).index())
    //           else that.setSearchList(that.searchList, that.tabIndex, that.radioIndex, $(this).index())
    //         }
    //         that.selectIndex = $(this).index()
    //         // 切换后重新给tab绑定事件 不然不能点击
    //         if (!(that.thirdField === "3")) {
    //           that.tabClick()
    //           that.radioClick()
    //         }
    //       })
    //   }, 100)
    // },
    async selectFun(typeId, index1, index2, index3) {
      const that = this
      that.searchTypeList = await that.getSearchTypeList(typeId)
      if (that.searchTypeList == "err") return
      that.setSearchTypeList(that.searchTypeList, index1, index2, index3)
    },
    // 点击tab切换
    // tabClick() {
    //   const that = this
    //   setTimeout(() => {
    //     $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
    //       .find(".tab")
    //       .on("click", function () {
    //         // 不知道为啥点击渲染数据之后这三个值就被重置了 所以重新赋值
    //         that.firstField = that.getElementInLayout().searchOptions.firstField
    //         that.secondField = that.getElementInLayout().searchOptions.secondField
    //         that.thirdField = that.getElementInLayout().searchOptions.thirdField
    //         if (that.tabIndex == $(this).index()) {
    //           return
    //         }
    //         if (that.firstField === "1") {
    //           that.selectIndex = 0 //重置下拉选中项
    //           that.radioIndex = 0 //重置单选选中项
    //           const typeId = that.selectOptions[$(this).index()].value
    //           that.selectFun(typeId, $(this).index(), that.radioIndex, that.selectIndex)
    //         } else if (that.secondField === "1") {
    //           // 判断是否需要获取搜索引擎
    //           if (that.searchTypeList.length > 0)
    //             that.setSearchTypeList(that.searchTypeList, $(this).index(), that.radioIndex, that.selectIndex)
    //           else that.setSearchList(that.searchList, $(this).index(), that.radioIndex, that.selectIndex)
    //         }
    //         that.tabIndex = $(this).index()
    //         // 切换后重新绑定事件 不然不能点击
    //         if (!(that.thirdField === "1")) {
    //           that.selectClick()
    //           that.radioClick()
    //         }
    //       })
    //   }, 100)
    // },
    // 点击radio切换
    // radioClick() {
    //   const that = this
    //   setTimeout(() => {
    //     $(`.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}`)
    //       .find(".radio")
    //       .on("click", function () {
    //         that.firstField = that.getElementInLayout().searchOptions.firstField
    //         that.secondField = that.getElementInLayout().searchOptions.secondField
    //         that.thirdField = that.getElementInLayout().searchOptions.thirdField
    //         if (that.radioIndex == $(this).index()) {
    //           return
    //         }
    //         if (that.firstField === "2") {
    //           const typeId = that.selectOptions[$(this).index()].value
    //           that.selectFun(typeId, that.tabIndex, $(this).index(), that.selectIndex)
    //         } else if (that.secondField === "2") {
    //           // 判断是否需要获取搜索引擎
    //           if (that.searchTypeList.length > 0)
    //             that.setSearchTypeList(that.searchTypeList, that.tabIndex, $(this).index(), that.selectIndex)
    //           else that.setSearchList(that.searchList, that.tabIndex, $(this).index(), that.selectIndex)
    //         }
    //         that.radioIndex = $(this).index()
    //         // 切换后重新绑定事件 不然不能点击
    //         if (!(that.thirdField === "2")) {
    //           that.selectClick()
    //           that.tabClick()
    //         }
    //       })
    //   }, 100)
    // },
    // 获取搜索基本组件
    getElementInLayout() {
      const searchMsg = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }
      const searchOptions = [this.options.rows[0]]
      const searchUid = getAllColsUidInLayoutComponent(searchOptions)[0]
      const searchElementInLayout = handleFindLayoutComponentOptions(searchOptions, searchUid)
      return {
        searchOptions: this.options,
        searchMsg: searchMsg,
        searchUid: searchUid,
        searchElementInLayout: searchElementInLayout
      }
    },
    // 获取数据
    async getSearchList(appId) {
      return new Promise((resolve, reject) => {
        this.$API
          .querySearchEngineList({
            appId: appId
          })
          .then(res => {
            if (res.data.code === 1) {
              if (res.data.data?.p) {
                this.$changeOptionsEV(res.data.data.p, "publicId", false)
              }
              if (res.data.data.datas.length > 0) {
                // 遍历列表，如果有一项的groupSearch为true，则初始化聚合搜索列表页的模版
                res.data.data.datas.forEach(item => {
                  if (item.groupSearch) {
                    this.initGroupSearchPageTemplate(appId)
                  }
                })
              }
              if (res.data.data) resolve(res.data.data.datas)
              else resolve([])
            } else {
              reject("err")
            }
          })
      })
    },
    // 如果是聚合搜索列表页，需要初始化化聚合搜索列表页的模版
    initGroupSearchPageTemplate(appId) {
      const firstLevelName = this.request_prefix === "stage" ? "搜索列表页" : "移动端搜索列表页"
      const menuType = this.request_prefix === "stage" ? "menu" : "appMenu"
      const searchList = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]
        ?.subs
      const subLevelName = this.request_prefix === "stage" ? "聚合检索列表页" : "移动端聚合检索列表页"
      const encId = searchList?.filter(item => item.name === subLevelName)[0].encId
      this.$API
        .queryComponentList({
          typeId: encId,
          p: 1,
          p2: 10,
          lsc: true
        })
        .then(res => {
          console.log("this.styleDatas :>>", res.data?.data?.PageInfo?.list)
          if (res.data?.data?.PageInfo?.list.length > 0) {
            // 根据appId找到对应的子页面关系
            let subPageMapping = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix].page?.subPages))
            const index = this.$store.state[this.request_prefix].page?.subPages.findIndex(item => item.appId === appId)

            // 如果当前的模版不属于聚合搜索列表页，才需要初始化聚合搜索列表页的模版,即subPageMapping[index]["listPageTemplateId"]在res.data?.data?.PageInfo?.list中存在
            if (
              res.data?.data?.PageInfo?.list.findIndex(
                item => item.publicId === subPageMapping[index]["listPageTemplateId"]
              ) === -1
            ) {
              // 找到默认的聚合搜索列表页模版
              const defaultGroupSearchPageTemplate = res.data?.data?.PageInfo?.list[0].publicId
              // 更新子页面映射关系
              subPageMapping[index]["listPageTemplateId"] = defaultGroupSearchPageTemplate
              updateSubPageMapping.call(this, subPageMapping, appId)
            }
          }
        })
    },
    // 查询引擎下分类
    async getSearchTypeList(typeId) {
      return new Promise((resolve, reject) => {
        this.$API
          .querySearchEngineClassify({
            typeId: typeId
          })
          .then(res => {
            if (res.data.code === 1) {
              resolve(res.data.data.searchTypeList)
            } else {
              reject("err")
            }
          })
      })
    },
    // 渲染搜索引擎组件基本信息
    setSearchList(searchList, tabIndex, radioIndex, selectIndex) {
      if (searchList.length === 0) return
      const getElement = this.getElementInLayout()
      const selectList = []
      if (Array.isArray(searchList)) {
        searchList.forEach(item => {
          /* isEnable:是否发布 */
          if (item.isEnable) {
            selectList.push({
              label: item.name,
              value: item.encId,
              link: item.link,
              name: item.name,
              content: item.id,
              des: item.des,
              linkDes: item.searchDetailDes ? item.searchDetailDes : "" //只有站内搜索的一级有提示语
            })
          }
        })
      }
      // getElement.searchElementInLayout.forEach(element => {
      //   if (this.firstField == "3") {
      //     switch (element.searchType) {
      //       case "searchSelect":
      //         this.$changeOptionsEV(selectList, "selectOptions", false, null, this.selectIds)
      //         // 返回第一个搜索引擎的值
      //         let label = selectList.length > 0 ? (selectList[0] ? selectList[0].label : selectList[0].label) : ""
      //         this.$changeOptionsEV(label, "value", false, null, this.selectIds)
      //         break
      //       default:
      //         break
      //     }
      //   } else if (this.firstField == "1") {
      //     switch (element.searchType) {
      //       case "searchTabs":
      //         this.$changeOptionsEV(selectList, "tabsList", false, null, this.tabsIds)
      //         this.$changeOptionsEV(tabIndex, "activeIndex", false, null, this.tabsIds)
      //         break
      //       default:
      //         break
      //     }
      //   } else if (this.firstField == "2") {
      //     switch (element.searchType) {
      //       case "searchRadio":
      //         this.$changeOptionsEV(selectList, "radioLists", false, null, this.radioIds)
      //         this.$changeOptionsEV(radioIndex, "activeIndex", false, null, this.radioIds)
      //         break
      //       default:
      //         break
      //     }
      //   }
      // })
      if (this.firstField == "3") {
        this.setOptions("searchSelect", "selectOptions", selectList)
        // 返回第一个搜索引擎的值
        let label = selectList.length > 0 ? (selectList[0] ? selectList[0].label : selectList[0].label) : ""
        this.setOptions("searchSelect", "value", label)
      } else if (this.firstField == "1") {
        this.setOptions("searchTabs", "tabsList", selectList)
        this.setOptions("searchTabs", "activeIndex", tabIndex)
      } else if (this.firstField == "2") {
        this.setOptions("searchRadio", "radioLists", selectList)
        this.setOptions("searchRadio", "activeIndex", radioIndex)
      }
      let listIdx = 0
      if (this.firstField == "1") {
        listIdx = tabIndex
      } else if (this.firstField == "2") {
        listIdx = radioIndex
      } else if (this.firstField == "3") {
        listIdx = selectIndex
      }
      this.searchType = searchList[listIdx].type
      this.setSearchTypeList(searchList[listIdx].searchTypeList, tabIndex, radioIndex, selectIndex)
    },
    // 渲染引擎下的分类
    setSearchTypeList(list, tabIndex, radioIndex, selectIndex = 0) {
      const getElement = this.getElementInLayout()
      const searchTypeList = []
      const subSearchTypeList = []
      let linkUrl = "", foreignLinkUrl = "", seniorLinkUrl = "", aiLinkUrl = ""
      let secondIndex = 0, thirdIndex = 0
      let activeSearchData = null
      if (this.secondField === "1") {
        secondIndex = tabIndex
      } else if (this.secondField === "2") {
        secondIndex = radioIndex
      } else if (this.secondField === "3") {
        secondIndex = selectIndex
      }
      if (this.thirdField == "1") {
        thirdIndex = tabIndex
      } else if (this.thirdField == "2") {
        thirdIndex = radioIndex
      } else if (this.thirdField == "3") {
        thirdIndex = selectIndex
      }
      const currentData = this.options?.activeSearchData
      let secondList = []
      let currenList // 当前选中项的值
      if (Array.isArray(list)) {
        list.forEach(item => {
          searchTypeList.push({
            name: item.name,
            content: item.id,
            label: item.name,
            value: item.encId,
            link: item.link,
            des: currentData ? currentData.des : "",// 说明只有一级分类才有
            linkDes: item.linkDes //提示语
          })
        })
        secondList = list[secondIndex]
        if (secondList && this.secondField) {
          currenList = secondList
          activeSearchData = searchTypeList[secondIndex]
        }
      }
      const dataList = secondList && secondList.subSearchTypeList
      if (secondList && Array.isArray(dataList)) {
        dataList.forEach(item => {
          subSearchTypeList.push({
            name: item.name,
            content: item.id,
            label: item.name,
            value: item.encId,
            link: item.link,
            des: currentData ? currentData.des : "",// 说明只有一级分类才有
            linkDes: item.linkDes //提示语
          })
        })
        if (dataList[thirdIndex] && this.thirdField) {
          currenList = dataList[thirdIndex]
          activeSearchData = subSearchTypeList[thirdIndex]
        }
      }
      if (currenList) {
        linkUrl = currenList.link ? currenList.link : ""
        foreignLinkUrl = currenList.foreignLink ? currenList.foreignLink : ""
        seniorLinkUrl = currenList.seniorLink ? currenList.seniorLink : ""
        aiLinkUrl = currenList.aiLink ? currenList.aiLink : ""
      }
      // 当字段匹配为空时 隐藏相应的组件
      if (this.firstField != "1" && this.secondField != "1" && this.thirdField != "1") {
        // this.tabElement.hide()
        this.setOptions("searchTabs", "isShow", false)
      }
      if (this.firstField != "2" && this.secondField != "2" && this.thirdField != "2") {
        // this.radioElement.hide()
        this.setOptions("searchRadio", "isShow", false)
      }
      if (this.firstField != "3" && this.secondField != "3" && this.thirdField != "3") {
        // this.selectElement.hide()
        this.setOptions("searchSelect", "isShow", false)
      }
      const searchInput = this.findElementIds(getElement.searchElementInLayout, "searchInput")?.element
      searchInput ? linkUrl = linkUrl + "&sw=" + encodeURIComponent(searchInput?.inputValue) : ""
      this.setOptions("searchButton", "linkUrl", linkUrl)
      this.setOptions("searchHigh", "linkUrl", seniorLinkUrl)
      this.setOptions("searchForeign", "linkUrl", foreignLinkUrl)
      this.setOptions("searchAi", "linkUrl", aiLinkUrl)
      this.setOptions("searchHigh", "isShow", seniorLinkUrl && this.showHighSearch ? true : false)
      this.setOptions("searchForeign", "isShow", foreignLinkUrl && this.showForeignSearch ? true : false)
      this.setOptions("searchAi", "isShow", (this.searchType === 4 || this.searchType === 7) && aiLinkUrl && this.showAiSearch ? true : false)
      if (activeSearchData !== null) {
        this.$changeOptionsEV(activeSearchData, "activeSearchData", false, null, this.ids, true)
        this.emitEvent(`searchDataUpdate-${this.ids.container_id}-${this.ids.rect_id}`, {
          type: 0,
          activeData: activeSearchData 
        })
      }
      // getElement.searchElementInLayout.forEach(element => {
        // switch (element.searchType) {
        //   case "searchInput":
        //     linkUrl = linkUrl + "&sw=" + encodeURIComponent(element.inputValue)
        //     break
        //   case "searchButton":
        //     this.$changeOptionsEV(linkUrl, "linkUrl", false, null, {
        //       uid: getElement.searchUid,
        //       elementInLayoutId: element.elementInLayoutId,
        //       ...getElement.searchMsg
        //     })
        //     break
        //   default:
        //     break
        // }
        // 二级标签
        if (this.secondField == "1") {
          if (searchTypeList.length > 0) {
            // this.tabElement.show()
            this.setOptions("searchTabs", "isShow", true)
          } else {
            // this.tabElement.hide()
            this.setOptions("searchTabs", "isShow", false)
          }
          this.setOptions("searchTabs", "tabsList", searchTypeList)
          this.setOptions("searchTabs", "activeIndex", tabIndex)
          // switch (element.searchType) {
          //   case "searchTabs":
          //     this.$changeOptionsEV(searchTypeList, "tabsList", false, null, this.tabsIds)
          //     this.$changeOptionsEV(tabIndex, "activeIndex", false, null, this.tabsIds)
          //     break
          //   default:
          //     break
          // }
        } else if (this.secondField == "2") {
          if (searchTypeList.length > 0) {
            // this.radioElement.show()
            this.setOptions("searchRadio", "isShow", true)
          } else {
            // this.radioElement.hide()
            this.setOptions("searchRadio", "isShow", false)
          }
          this.setOptions("searchRadio", "radioLists", searchTypeList)
          this.setOptions("searchRadio", "activeIndex", radioIndex)
          // switch (element.searchType) {
          //   case "searchRadio":
          //     this.$changeOptionsEV(searchTypeList, "radioLists", false, null, this.radioIds)
          //     this.$changeOptionsEV(radioIndex, "activeIndex", false, null, this.radioIds)
          //     break
          //   default:
          //     break
          // }
        } else if (this.secondField == "3") {
          if (searchTypeList.length > 0) {
            // this.selectElement.show()
            this.setOptions("searchSelect", "isShow", true)
          } else {
            // this.selectElement.hide()
            this.setOptions("searchSelect", "isShow", false)
          }
          this.setOptions("searchSelect", "selectOptions", searchTypeList)
          let label =
            searchTypeList.length > 0
              ? searchTypeList[selectIndex]
                ? searchTypeList[selectIndex].label
                : searchTypeList[0].label
              : ""
          // 返回第一个搜索引擎的值
          this.setOptions("searchSelect", "value", label)
          // switch (element.searchType) {
          //   case "searchSelect":
          //     this.$changeOptionsEV(searchTypeList, "selectOptions", false, null, this.selectIds)
          //     let label =
          //       searchTypeList.length > 0
          //         ? searchTypeList[selectIndex]
          //           ? searchTypeList[selectIndex].label
          //           : searchTypeList[0].label
          //         : ""
          //     // 返回第一个搜索引擎的值
          //     this.$changeOptionsEV(label, "value", false, null, this.selectIds)
          //     break
          //   default:
          //     break
          // }
        }
        // 三级标签
        if (this.thirdField == "1") {
          if (subSearchTypeList.length > 0) {
            // this.tabElement.show()
            this.setOptions("searchTabs", "isShow", true)
          } else {
            // this.tabElement.hide()
            this.setOptions("searchTabs", "isShow", false)
          }
          this.setOptions("searchTabs", "tabsList", subSearchTypeList)
          this.setOptions("searchTabs", "activeIndex", tabIndex)
          // switch (element.searchType) {
          //   case "searchTabs":
          //     this.$changeOptionsEV(subSearchTypeList, "tabsList", false, null, this.tabsIds)
          //     this.$changeOptionsEV(tabIndex, "activeIndex", false, null, this.tabsIds)
          //     break
          //   default:
          //     break
          // }
        } else if (this.thirdField == "2") { 
          if (subSearchTypeList.length > 0) {
            // this.radioElement.show()
            this.setOptions("searchRadio", "isShow", true)
          } else {
            // this.radioElement.hide()
            this.setOptions("searchRadio", "isShow", false)
          }
          this.setOptions("searchRadio", "radioLists", subSearchTypeList)
          this.setOptions("searchRadio", "activeIndex", radioIndex)
          // switch (element.searchType) {
          //   case "searchRadio":
          //     this.$changeOptionsEV(subSearchTypeList, "radioLists", false, null, this.radioIds)
          //     this.$changeOptionsEV(radioIndex, "activeIndex", false, null, this.radioIds)
          //     break
          //   default:
          //     break
          // }
        } else if (this.thirdField == "3") {
          if (subSearchTypeList.length > 0) {
            // this.selectElement.show()
            this.setOptions("searchSelect", "isShow", true)
          } else {
            // this.selectElement.hide()
            this.setOptions("searchSelect", "isShow", false)
          }
          this.setOptions("searchSelect", "selectOptions", subSearchTypeList)
          // 返回第一个搜索引擎的值
          let label =
          subSearchTypeList.length > 0
            ? subSearchTypeList[selectIndex]
              ? subSearchTypeList[selectIndex].label
              : subSearchTypeList[0].label
            : ""
            this.setOptions("searchSelect", "value", label)
          // switch (element.searchType) {
          //   case "searchSelect":
          //     this.$changeOptionsEV(subSearchTypeList, "selectOptions", false, null, this.selectIds)
          //     // 返回第一个搜索引擎的值
          //     let label =
          //       subSearchTypeList.length > 0
          //         ? subSearchTypeList[selectIndex]
          //           ? subSearchTypeList[selectIndex].label
          //           : subSearchTypeList[0].label
          //         : ""
          //     this.$changeOptionsEV(label, "value", false, null, this.selectIds)
          //     break
          //   default:
          //     break
          // }
        }
      // })
    },
    clearClick(type) {
      console.log("type :>>", type)
      switch (type) {
        case 1:
          this.firstField = ""
          this.secondField = ""
          this.thirdField = ""
          break
        case 2:
          this.secondField = ""
          this.thirdField = ""
          break
        case 3:
          this.thirdField = ""
          break
        default:
      }
    },
    listenData(e) {
      let id = window.localStorage.getItem("page-v2-search-update-id")
      if (e.key == "page-v2-search-update") {
        if (id == this.appId) {
          console.log("后台配置或数据更新 :>>")
          this.btnClick()
        }
      }
    }
  }
}
</script>

<style>
.goManageBack {
  display: block;
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  width: 100%;
  height: 32px;
  font-size: 14px;
  line-height: 30px;
  color: var(--themeColor);
  text-align: center;
  cursor: pointer;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  padding: 6px 0px;
  cursor: pointer;
}
.select-box {
  position: relative;
}
.select-box .del-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.2);
  background: var(--inputBackGround);
  display: none;
}
.select-box:hover .del-btn {
  display: block;
}
</style>
